"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Icon = _interopRequireDefault(require("../../Icon"));
var _constant = require("../../constant");
var _utilities = _interopRequireDefault(require("../../../utilities"));
var _card = _interopRequireDefault(require("./card.proptypes"));
var _constant2 = require("../constant");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var hoverCss = (0, _styledComponents.css)(["&:hover{background:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.greyLighter;
});
var Container = _styledComponents.default.div.withConfig({
  displayName: "TripTypes__Container",
  componentId: "sc-1xgnhxw-0"
})(["", ";background:", ";padding:", ";"], function (_ref2) {
  var hoverSource = _ref2.hoverSource;
  return hoverSource === _constant2.HoverSource.MouseOver ? hoverCss : '';
}, function (_ref3) {
  var theme = _ref3.theme,
    isHovered = _ref3.isHovered;
  return isHovered ? theme.colors.greyLighter : 'transparent';
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.small;
});
var CardContent = _styledComponents.default.div.withConfig({
  displayName: "TripTypes__CardContent",
  componentId: "sc-1xgnhxw-1"
})(["display:flex;justify-content:space-between;"]);
var Label = _styledComponents.default.div.withConfig({
  displayName: "TripTypes__Label",
  componentId: "sc-1xgnhxw-2"
})(["font-family:", ";font-size:", ";line-height:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontFamily.default;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontSize.small;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.lineHeight.titleSmall;
});
var Card = function Card(props) {
  var label = props.label,
    code = props.code,
    type = props.type,
    url = props.url,
    onSelectionDone = props.onSelectionDone,
    displaySelected = props.displaySelected,
    isHovered = props.isHovered,
    onMouseMove = props.onMouseMove,
    hoverSource = props.hoverSource,
    id = props.id;
  return /*#__PURE__*/_react.default.createElement(Container, {
    id: id,
    accessible: true,
    onKeyDown: function onKeyDown(e) {
      return _utilities.default.keyDownHandler(e, onSelectionDone(label, code, type, url, e.key), _constant.KEY_CODE.ENTER);
    },
    onClick: function onClick() {
      return onSelectionDone(label, code, type, url, 'Click');
    },
    isHovered: isHovered,
    onMouseMove: onMouseMove,
    hoverSource: hoverSource
  }, /*#__PURE__*/_react.default.createElement(CardContent, {
    tabIndex: 0
  }, /*#__PURE__*/_react.default.createElement(Label, null, label), /*#__PURE__*/_react.default.createElement("div", null, displaySelected === code && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    accessible: false,
    color: _constant2.DEFAULT_STYLE.SELECTED_ICON.COLOR,
    fontsize: _constant2.DEFAULT_STYLE.SELECTED_ICON.SIZE,
    icon: _constant2.DEFAULT_STYLE.SELECTED_ICON.ICON_CHECK
  }), type === _constant2.REDIRECT && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    accessible: false,
    color: _constant2.DEFAULT_STYLE.SELECTED_ICON.COLOR,
    fontsize: _constant2.DEFAULT_STYLE.SELECTED_ICON.SIZE,
    icon: _constant2.DEFAULT_STYLE.SELECTED_ICON.ICON_REDIRECT
  }))));
};
Card.propTypes = _card.default.PropTypes;
Card.defaultProps = _card.default.DefaultProps;
var _default = Card;
exports.default = _default;